<template>
    <div
        class="ImageAndText paddingSize"
        :style="{
            marginTop: data.marginTop + 'px',
            paddingTop: data.paddingTop + 'px',
        }"
    >
        <div class="form_item" v-if="data.content || data.data.length > 0">
            <div class="form_item_title">
                <img src="../../assets/images/one.png" alt="" />
            </div>
            <div class="form_item_title title_name">
                <span>{{ data.content }}</span>
            </div>

            <div class="form_item_content">
                <div class="content_img">
                    <img
                        v-for="(item, index) in data.data"
                        :key="index"
                        :src="item.url"
                    />
                </div>
                <div class="content_text">{{ data.details }}</div>
            </div>
        </div>

        <div class="form_item" v-else>
            <div class="form_item_title">
                <img src="../../assets/images/one.png" alt="" />
            </div>
            <div class="form_item_title title_name">
                <span>标题文字</span>
            </div>

            <div class="form_item_content">
                <div class="content_img">
                    <img src="../../assets/images/one_content.png" alt="" />
                </div>
                <div class="content_text">这内容详情</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ImageAndText",
    props: ["data"],
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/curriculum.scss";
.content_text {
    white-space: pre-line;
}
</style>